import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppSessionState } from './app-session.state';

export const selectAppSession = createFeatureSelector<AppSessionState | null>('appSession');

export const selectAccessToken = createSelector(selectAppSession, (session) => (session ? session.accessToken : null));

export const selectIsAuthenticated = createSelector(selectAppSession, (session) => !!session);

export const selectUserRoles = createSelector(selectAppSession, (session) => session?.roleList || []);

export const selectUserInitials = createSelector(selectAppSession, (session) => session?.initials || 'U');

export const selectUserId = createSelector(selectAppSession, (session) => session?.userId || '');

export const selectIsMisc = createSelector(selectAppSession, (session) => session?.isMisc || false);
